import { FiChevronRight, FiHelpCircle } from "react-icons/fi";
import img1 from "../../../assets-user/Img1.png";
import img2 from "../../../assets-user/Img2.png";
import img3 from "../../../assets-user/Img3.png";
import img4 from "../../../assets-user/Img4.png";
import img5 from "../../../assets-user/Img5.png";

const MarketInsights = () => {
  const insights = [
    {
      id: 1,
      title: "Top Articles on Buying Guide",
      description:
        "This Buying Guide will guide you step-by-step in buying a property.",
      image: img1,
      bgColor: "bg-blue-50",
      animation: "fade-up",
    },
    {
      id: 2,
      title: "LeadBook Property Buying Guide",
      description:
        "Step-by-step guide to buying property with confidence and ease.",
      image: img2,
      bgColor: "bg-amber-50",
      animation: "zoom-in",
    },
    {
      id: 3,
      title: "Your Smart Buying Guide",
      description:
        "Simplifying property buying through smart tips, insights, and expert guidance.",
      image: img3,
      bgColor: "bg-cyan-50",
      animation: "flip-left",
    },
    {
      id: 4,
      title: "Home Buying Made Simple",
      description:
        "Learn how to buy property safely, quickly, and with confidence.",
      image: img4,
      bgColor: "bg-purple-50",
      animation: "fade-right",
    },
    {
      id: 5,
      title: "The Complete Buyer's Checklist",
      description:
        "Your trusted guide for hassle-free, transparent, and smarter property purchases.",
      image: img5,
      bgColor: "bg-orange-50",
      animation: "fade-left",
    },
  ];

  return (
    <div className="bg-white py-6 md:py-8 lg:py-10 px-4 sm:px-6 md:px-8 lg:px-10">
      <div className="mx-auto">
        <div className="flex items-center justify-between mb-1 sm:mb-2 md:mb-3 lg:mb-4">
          <h2 className="font-medium text-[#031722] tracking-[0.01em] leading-[150%] text-lg sm:text-xl md:text-2xl lg:text-3xl mb-1 sm:mb-2 md:mb-3 lg:mb-4">
            Market Insights
          </h2>
          <button className="flex items-center gap-1 text-red-600 font-medium text-sm sm:text-base">
            View More
            <FiChevronRight className="w-4 h-4 sm:w-5 sm:h-5" />
          </button>
        </div>

        <div className="flex overflow-x-auto lg:overflow-hidden gap-4 md:gap-6 lg:grid lg:grid-cols-5 scroll-smooth snap-x snap-mandatory">
          {insights.map((insight) => (
            <div
              key={insight.id}
              className={`${insight.bgColor} rounded-2xl overflow-hidden shadow-sm border border-gray-200 cursor-pointer flex-shrink-0 w-[80%] md:w-[70%] lg:w-auto snap-start`}
            >
              <div className="p-4 sm:p-5">
                <div className="flex items-start justify-between gap-2 mb-2">
                  <h3 className="font-medium text-[#031722] tracking-[0.01em] leading-[150%] text-base sm:text-lg md:text-xl lg:text-[18.7px] mb-2">
                    {insight.title}
                  </h3>
                  <button className="flex-shrink-0 text-gray-400">
                    <FiHelpCircle className="w-4 h-4 sm:w-5 sm:h-5" />
                  </button>
                </div>
                <p className="font-normal text-[#6A6A6A] tracking-[0.01em] text-sm sm:text-base md:text-[14.54px] mb-2">
                  {insight.description}
                </p>
              </div>

              <div
                className="relative overflow-hidden"
                data-aos={insight.animation}
                data-aos-duration="1000"
                data-aos-once="true"
              >
                <img
                  src={insight.image}
                  alt={insight.title}
                  className="w-full object-contain"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MarketInsights;
